export const TopicLabel = (
  topic,
  t,
  fallback,
  prefix = "metric.topic",
  isCustom = false,
) => {
  if (!topic && !fallback) return "-";
  if (typeof t !== "function") return fallback || topic || "-";
  // Custom framework codes/topics are user-authored — resolving them through
  // the shared i18n tables mispairs titles (codes like "E001" collide with
  // standard framework keys).
  if (isCustom) return fallback || String(topic).trim() || "-";
  const key = String(topic).trim();
  const defaultValue = fallback || key || "-";
  const titleCase = key
    ? key[0].toUpperCase() + key.slice(1).toLowerCase()
    : "";
  return (
    t(`${prefix}.${key}`, { defaultValue: "" }) ||
    t(`${prefix}.${key.toUpperCase()}`, { defaultValue: "" }) ||
    t(`${prefix}.${titleCase}`, { defaultValue: "" }) ||
    defaultValue
  );
};

// Display title for a disclosure/metric object ({ code, title, isCustom }).
// Takes the whole object so call sites cannot forget the custom-framework
// bypass above — the regression class behind the metric-names-mismatch bug.
TopicLabel.forMetric = (metric, t) =>
  TopicLabel(
    metric?.code,
    t,
    metric?.title,
    "metric.topic",
    Boolean(metric?.isCustom),
  );

TopicLabel.options = (prefix, t) => {
  if (typeof t !== "function" || !prefix) return [];
  const data = t(prefix, { returnObjects: true }) || {};
  if (typeof data !== "object" || data === null) return [];
  return Object.keys(data).map((key) => ({
    value: key,
    label: TopicLabel(key, t, data[key] || key, prefix),
  }));
};

TopicLabel.withAll = (list, allLabelOrKey, tOrValue, allValue = "all") => {
  let label = allLabelOrKey;
  let resolvedValue = allValue;

  if (typeof tOrValue === "function") {
    label = tOrValue(allLabelOrKey, { defaultValue: allLabelOrKey });
  } else if (typeof tOrValue === "string") {
    resolvedValue = tOrValue;
  }

  return [
    { value: resolvedValue, label },
    ...(list || []).filter((opt) => (opt.value ?? opt.key) !== resolvedValue),
  ];
};

TopicLabel.join = (
  segments,
  t,
  fallback,
  prefix = "metric.topic",
  separator = " / ",
) => {
  const list =
    Array.isArray(segments) && segments.length
      ? segments
      : [typeof segments === "string" ? segments : fallback];
  return list.map((item) => resolveParameter(item, t, prefix)).join(separator);

  function resolveParameter(item, t, prefix) {
    if (typeof item === "string") return TopicLabel(item, t, item, prefix);

    const key = item?.key ?? item?.id ?? item?.value ?? "";
    const title = item?.title ?? item?.label ?? item?.name ?? key;

    return TopicLabel(key || title, t, title, prefix);
  }
};
